// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__20xWn","title":"ClientReferral_title__1D0gk","itemText":"ClientReferral_itemText__MEKC_"};